import { useMutation } from '@tanstack/react-query';
import axios from '../../axios';

const requestPrice = async (listingId: string) => {
    const { data } = await axios.post(`/api/buyer/price-requests/${listingId}`);
    return data;
};

export const useRequestPrice = () =>
    useMutation({
        mutationFn: (listingId: string) => requestPrice(listingId),
    });
